import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HomePage } from "./components/Home/Home";
import AboutUS from "./components/Home/AboutUs";
import { OurServices } from "./components/Home/OurServices";
import ContactUs from "./components/Home/ContactUs";
import Blogs from "./components/Home/Blogs";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./index.css";
import ScrollToTop from "./components/Home/scrollToTop";
import OurProjects from "./components/Home/OurProjects";
import { TermsCondition } from "./components/Home/TermsConditions";
import { PrivacyPolicy } from "./components/Home/PrivacyPolicy";
import BlogPost from "./components/Home/BlogPost";
import SetPageTitle from "./components/Home/SetPageTitle";
function App() {
  return (
    <Router>
   
      <ScrollToTop />

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/aboutus" element={<AboutUS />} />
        <Route path="/ourservices" element={<OurServices />} />
        <Route path="/ourprojects" element={<OurProjects />} />
        <Route path="/blogs" element={<Blogs />} />
         <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/contactus" element={<ContactUs />} />
        <Route path="/termsconditions" element={<TermsCondition/>}/>
        <Route path="/privacypolicy" element={<PrivacyPolicy/>}/>
        <Route path="/setpagetitle" element={<SetPageTitle/>}/>
      </Routes>
    </Router>
  );
}

export default App;
